interface Props {
  height?: string;
  width?: string;
  shape?: 'circle' | 'rectangle' | 'curvedRectangle';
  style?: object;
}

const CustomSkeleton = ({ height = '100%', width = "100%", shape, style = {} }: Props) => {
  const borderRadiusMapping = {
    circle: '50%',
    rectangle: '0',
    curvedRectangle: '8px'
  }

  return (
    <div style={{
      height,
      width,
      borderRadius: borderRadiusMapping[shape || 'rectangle'],
      overflow: 'hidden',
      background: '#c5c5c5',
      display: 'inline-block',
      ...style
    }}

    >
      <div className='skeleton-container'>
      </div>
    </div>
  );
}

export default CustomSkeleton